import React from "react";
import injectSheet from "react-jss";
import { Expandable } from "folksam-ui";
import ItemList from "components/ItemList";
import { Element as ScrollAnchorElement } from "react-scroll/modules";

const style = ({ theme }) => ({
  root: {
    padding: 0
  },
  header: {
    color: theme.colors.primary5
  },
  headerExpanded: {
    color: "red"
  },
  body: {
    height: 0,
    overflow: "hidden"
  },
  bodyExpanded: {
    height: "auto"
  }
});

const ArrayFieldItemTemplate = ({
  classes,
  index,
  children,
  readonly,
  disabled,
  hasToolbar,
  hasMoveUp,
  hasRemove,
  hasMoveDown,
  showEdit,
  onReorderClick,
  onDropIndexClick,
  heading
}) => {
  if (hasMoveDown || hasMoveUp) {
    console.warn("Orderable is not supported");
  }
  const key = `${heading}-${index}`;

  return (
    <>
      <ScrollAnchorElement name={key} />

      <Expandable.Section id={key} key={key}>
        {({ handleClick, expanded }) => (
          <div>
            <ItemList.Header
              id={key}
              showEdit={showEdit}
              expanded={expanded}
              onRemoveClick={onDropIndexClick(index)}
              readOnly={readonly}
              disabled={disabled}
              heading={heading}
              onExpandClick={handleClick}
            />
            <ItemList.Body expanded={expanded} id={key}>
              {children}
            </ItemList.Body>
          </div>
        )}
      </Expandable.Section>
    </>
  );
};

export default injectSheet(style)(ArrayFieldItemTemplate);
